(function () {
  const storageKey = "rudraWishlist";
  const maxItems = 24;

  const readWishlist = () => {
    try {
      const items = JSON.parse(localStorage.getItem(storageKey) || "[]");
      return Array.isArray(items) ? items : [];
    } catch (error) {
      return [];
    }
  };

  const normalizeItem = (item) => {
    if (typeof item === "string" || typeof item === "number") {
      return { id: String(item) };
    }

    if (!item || typeof item !== "object") {
      return { id: "" };
    }

    return {
      id: String(item.id || item.productId || ""),
      handle: item.handle || "",
      title: item.title || "",
      url: item.url || "",
      image: item.image || "",
      price: item.price || ""
    };
  };

  const writeWishlist = (items) => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(items));
    } catch (error) {
      // Keep the UI from breaking if storage is temporarily unavailable.
    }
  };

  const getProductFromButton = (button) => ({
    id: String(button.dataset.productId || ""),
    handle: button.dataset.productHandle || "",
    title: button.dataset.productTitle || "",
    url: button.dataset.productUrl || "",
    image: button.dataset.productImage || "",
    price: button.dataset.productPrice || ""
  });

  const getWishlistItems = () => readWishlist().map(normalizeItem).filter((item) => item.id);

  const getWishlistIds = () => new Set(getWishlistItems().map((item) => item.id));

  const updateButton = (button, active) => {
    button.classList.toggle("active", active);
    button.classList.toggle("is-active", active);
    button.textContent = button.hasAttribute("data-wishlist-label")
      ? (active ? "\u2665 Added to Wishlist" : "\u2661 Add to Wishlist")
      : (active ? "\u2665" : "\u2661");
    button.setAttribute("aria-pressed", active ? "true" : "false");
  };

  const syncWishlistButtons = () => {
    const ids = getWishlistIds();

    document.querySelectorAll("[data-wishlist]").forEach((button) => {
      const id = String(button.dataset.productId || "");
      updateButton(button, id !== "" && ids.has(id));
    });
  };

  const removeFromWishlist = (id) => {
    const itemId = String(id || "");
    const updated = getWishlistItems().filter((item) => item.id !== itemId);
    writeWishlist(updated);
  };

  const renderWishlistPage = () => {
    const section = document.querySelector("[data-wishlist-page]");
    if (!section) return;

    const grid = section.querySelector("[data-wishlist-grid]");
    const empty = section.querySelector("[data-wishlist-empty]");
    const items = getWishlistItems().filter((item) => item.title && item.url);

    if (!grid) return;

    grid.innerHTML = "";

    if (!items.length) {
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;

    items.forEach((item) => {
      const card = document.createElement("div");
      card.className = "rudra-card-wrap";

      const removeButton = document.createElement("button");
      removeButton.type = "button";
      removeButton.className = "rudra-card__wishlist active";
      removeButton.dataset.wishlistRemove = item.id;
      removeButton.setAttribute("aria-label", `Remove ${item.title} from wishlist`);
      removeButton.setAttribute("aria-pressed", "true");
      removeButton.textContent = "\u2665";
      card.appendChild(removeButton);

      const link = document.createElement("a");
      link.href = item.url;
      link.className = "rudra-card";

      const media = document.createElement("div");
      media.className = "rudra-card__media";

      if (item.image) {
        const image = document.createElement("img");
        image.src = item.image;
        image.alt = item.title;
        image.className = "rudra-card__image";
        image.loading = "lazy";
        media.appendChild(image);
      }

      link.appendChild(media);

      const content = document.createElement("div");
      content.className = "rudra-card__content";

      const meta = document.createElement("p");
      meta.className = "rudra-card__meta";
      meta.textContent = "Saved Watch";
      content.appendChild(meta);

      const title = document.createElement("h3");
      title.textContent = item.title;
      content.appendChild(title);

      const price = document.createElement("p");
      price.className = "rudra-card__price";
      price.textContent = item.price || "";
      content.appendChild(price);

      const cta = document.createElement("span");
      cta.className = "rudra-card__button";
      cta.textContent = "View Watch";
      content.appendChild(cta);

      link.appendChild(content);
      card.appendChild(link);
      grid.appendChild(card);
    });
  };

  const toggleWishlist = (button) => {
    const product = getProductFromButton(button);
    if (!product.id) return;

    const items = getWishlistItems();
    const exists = items.some((item) => item.id === product.id);
    const updated = exists
      ? items.filter((item) => item.id !== product.id)
      : [product, ...items.filter((item) => item.id !== product.id)].slice(0, maxItems);

    writeWishlist(updated);
    syncWishlistButtons();
    renderWishlistPage();
  };

  const handleWishlistClick = (event) => {
    const removeButton = event.target.closest("[data-wishlist-remove]");
    if (removeButton) {
      event.preventDefault();
      event.stopPropagation();
      removeFromWishlist(removeButton.dataset.wishlistRemove);
      syncWishlistButtons();
      renderWishlistPage();
      return;
    }

    const button = event.target.closest("[data-wishlist]");
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    toggleWishlist(button);
  };

  const initWishlist = () => {
    syncWishlistButtons();
    renderWishlistPage();
  };

  if (!window.rudraWishlistBound) {
    window.rudraWishlistBound = true;
    document.addEventListener("click", handleWishlistClick);
    document.addEventListener("shopify:section:load", initWishlist);
    window.addEventListener("pageshow", initWishlist);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initWishlist, { once: true });
  } else {
    initWishlist();
  }

  window.rudraWishlist = {
    refresh: initWishlist
  };
})();
